import { SUPABASE_URL, getDbHeaders } from "./client";

export async function dbSavePushSubscription(airline, sub) {
  const json = sub.toJSON();
  const headers = await getDbHeaders();
  // Delete any existing rows for this airline first, then insert the current endpoint.
  // This handles stale rows from previous sessions or other browsers without needing
  // a UNIQUE(airline) constraint (upsert merge-duplicates requires one).
  const delRes = await fetch(
    SUPABASE_URL + "/rest/v1/push_subscriptions?airline=eq." + encodeURIComponent(airline),
    { method: "DELETE", headers }
  ).catch(() => null);
  if (!delRes?.ok) return false;
  const res = await fetch(SUPABASE_URL + "/rest/v1/push_subscriptions", {
    method: "POST",
    headers: await getDbHeaders({ "Prefer": "return=minimal" }),
    body: JSON.stringify({
      airline,
      endpoint: json.endpoint,
      p256dh: json.keys.p256dh,
      auth: json.keys.auth,
      updated_at: new Date().toISOString(),
    }),
  });
  return res.ok;
}

export async function dbDeletePushSubscription(endpoint) {
  await fetch(SUPABASE_URL + "/rest/v1/push_subscriptions?endpoint=eq." + encodeURIComponent(endpoint), {
    method: "DELETE",
    headers: await getDbHeaders(),
  }).catch(() => {});
}
